






































































import { Component, Vue } from "vue-property-decorator";
import Disclaimer from "./Disclaimer.vue"

@Component({
    components:{
      Disclaimer
    }
})
export default class NavigationFooter extends Vue {
  contactUs = false;
  disclaimer = {show: false}
  mounted() {
    this.contactUs = false;
    this.disclaimer.show = false;
  }

}
